export const URI = process.env.VUE_APP_URI

export const MICROSERVICE_URLS = {
    DEVELOPMENT_PLANS: process.env.VUE_APP_DEVELOPMENT_PLANS_URL || 'http://localhost:25100',
    IMPROVEMENT_PLANS: process.env.VUE_APP_IMPROVEMENT_PLANS_URL || 'http://localhost:26101'
}

export const SERVICE_NAMES ={
    USER: 'serv-user',
    LOGIN: 'serv-auth/login',
    SECURE_LOGIN: 'serv-auth/secure-login',
    LOGOUT: 'serv-auth/logout',
    PERMISSION: 'serv-auth/permissions',
    POLICY: 'serv-policy',
    ACTIVITY: 'serv-activity',
    GENERAL_DB: 'serv-general-db',
    PROCESS: 'serv-process',
    COLLABORATOR: 'serv-collaborator',
    MUNIMENT: 'serv-muniment',
    WEIGHING: 'serv-weighing',
    EVIDENCE: 'serv-evidence',
	EXOGENOUS: 'serv-exogenous',
    INSTRUMENT: 'serv-instrument',
    TARGET: 'serv-target',
    EMAIL : 'serv-email',
    REVIEW: 'serv-review',
    SMTP: 'serv-smtp',
    MATRIX: 'serv-matrix',
    IMPROVEMENT_PLAN: 'serv-improvement-plan',
    CONTRACT: 'serv-contract',
    IMAGES: 'serv-images',
    DASHBOARD: 'serv-dashboard',
    DASHBOARD_ACTION: 'serv-dashboard-action',
    REPORT: 'serv-report',
    TEMPLATE: 'serv-template',
    SNIES_2: 'serv-snies-2',
    NOTES: 'serv-notes',
    CHAT: 'serv-chat',
    CALENDAR_SUBSCRIPTION: 'serv-calendar-subscription',
    REPOSITORY: 'serv_repository'
}

export const HTTP_STATUS = {
    OK: 200,
    NO_FOUND: 201,
    NO_CONTENT: 204,
    PARTIAL_CONTENT: 206,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    CONFLICT: 409,
    UNPROCESSABLE_ENTITY: 422,
    INTERNAL_SERVER_ERROR: 500,
}

//* MODULES 

export const MODULES ={
    HOME: 'Home',
    PROJECTS: 'Proyectos',
    CALENDAR: 'Mi Calendario',
    MATRIX: 'Matriz de evidencias',
    REVIEW: 'Evaluación final',
    TEACHER_REVIEW: 'Evaluación final (Docentes)',
    EVIDENCE: 'Evidencias',
    WEIGHING: 'Ponderación', // @a MODULO PARA ACCESO A REALIZACIÓN DE PONDERACIÓN
    INSTRUMENTS: 'Instrumentos',
    INSTRUMENT: 'Instrumento', // @a MODULO PARA ACCESO A APLICACIÓN DE INSTRUMENTO
    SERVER: 'Servidor', // @q MODULO DE PAGINAS DE PRUEBA
    SMTP: 'SMTP',
    IMPROVEMENT_PLAN: 'Plan de Mejora',
    CONTRACT: 'Contrato',
    DASHBOARD: 'Dashboard',
    TEMPLATES: 'Integración',
    NOTES: 'Notas',
    MY_NOTES: 'Mis Notas',
    REPOSITORY: 'Proyectos',
    ARTIFICIAL_INTELLIGENCE: 'Inteligencia Artificial'
}

export const SESSION_EXPIRATION = {
    IDLE_TIME: 15000, //15 seg -> 15 * 1000
    TIMEOUT: 3600000, //30 minutes -> 30 * 60 * 1000
    METHOD_INTERVAL: 3000 //2 segundos
}

export const TEACHER_SERVICE = {
    STANDARD: "DS"
    // STANDARD: "RV"
}


// export const API_KEY_TINY_MCE = 'gb965ai21xa8kcinmz3wrphdquxhu9bogplva8uklt87lg60' //Usar esta para localhost
export const API_KEY_TINY_MCE = 'p8jrbmchtstujol1a73ia548cjqejbzcha1ir84gvi4nyot9' //Usar esta para los demás
